module.exports = __webpack_public_path__ + "static/logo-williams-sonoma-aa41cbba5ae3d1063db598550abc9ec8.png";